module.exports = __webpack_public_path__ + "img/airplane.642c11d.png";